/* eslint-disable */

import { Loader } from 'google-maps';
import { style } from './mapStyle';
import { windowWidth } from './utils';

type Marker = {
  id: string;
  name: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  country: string;
  type: Type;
  url: string;
  phone: string;
  email: string;
  zip: string;
  lat: string;
  lng: string;
  distance: string;
};

type Type = 'Dealer' | 'Distributor';

const storeFinder = {
  map: null as any,
  loader: new Loader('AIzaSyC3Pep87jmCbuirH_G2_Ftd0f5A08cUYpw', {
    libraries: ['places', 'geometry'],
  }),
  markers: (window as any).markerJSON as Marker[],
  filterdMarkers: [] as Marker[],
  storeList: document.getElementById('storeList') as HTMLElement | undefined,
  resultWrap: document.getElementById('resultWrap') as HTMLElement | undefined,
  resultBtn: document.getElementById('resultTrigger') as HTMLElement | undefined,
  typeBtns: document.querySelectorAll('.jsType') as NodeListOf<HTMLInputElement>,
  selectedTypes: [] as Type[],
  bounds: {} as google.maps.LatLngBounds,
  search: document.getElementById('searchStoreInput') as HTMLInputElement | undefined,
  section: document.getElementById('jsSection') as HTMLElement | undefined,
  newSearch: document.getElementById('jsNewSearch') as HTMLElement | undefined,
  messageElement: document.getElementById('messageElement') as HTMLElement | undefined,
  autocomplete: undefined as google.maps.places.Autocomplete | undefined,
  lat: 0,
  lng: 0,
  pins: [] as google.maps.Marker[],
  typeFilterOpen: document.getElementById('typeFilterOpen') as HTMLElement | undefined,
  typeFilter: document.getElementById('typeFilter') as HTMLElement | undefined,
  markerCount: document.getElementById('markerCount') as HTMLElement | undefined,
  resetMarkers: document.getElementById('markerReset') as HTMLElement | undefined,
  defaultZoomLevel: 10,
  errorMessage: document.getElementById('errorMessage') as HTMLElement | undefined,
  totalResultsElement: document.getElementById('totalResults') as HTMLElement | undefined,
  toggleList: document.getElementById('jsToggleList') as HTMLElement | undefined,
  toggleMap: document.getElementById('jsToggleMap') as HTMLElement | undefined,
  mapWrap: document.getElementById('jsMapWrap') as HTMLElement | undefined,
  stockistAds: document.getElementById('jsStockistWrap') as HTMLElement | undefined,
  storeFinder: document.getElementById('jsStoreFinder') as HTMLElement | undefined,

  init() {
   
  if (!document.getElementById('map') || !document.getElementById('storeList')) {
    
    return;
  }
    this.loadMap();
    this.setMarkers();
    this.setTriger();
    this.filterTypes();
    this.zoomToPin();
    this.toggleFilter();
    this.setResetMarkers();
    this.goBackSearch();

    document.getElementById('findNearbyStores')?.addEventListener('click', () => {
      this.handleSearchClick();
    });


     this.setAll();

    if (windowWidth < 1200) {
      this.togglers();
    }
  },


    togglers() {
    this.toggleList?.addEventListener('click', () => {
      this.toggleList?.classList.add('activeClass');
      this.toggleMap?.classList.remove('activeClass');
      this.storeList?.parentElement?.classList.add('activeClass');
      this.mapWrap?.classList.remove('activeClass');
    });

    this.toggleMap?.addEventListener('click', () => {
      this.toggleList?.classList.remove('activeClass');
      this.toggleMap?.classList.add('activeClass');
      this.storeList?.parentElement?.classList.remove('activeClass');
      this.mapWrap?.classList.add('activeClass');
    });
  },

  setCounter() {
    const countMessage = this.filterdMarkers.length
      ? `See ${this.filterdMarkers.length} Locations`
      : 'Select Option';

    if (this.markerCount) {
      this.markerCount.innerText = countMessage;
    }

    if (this.totalResultsElement) {
      this.totalResultsElement.innerText = `${this.filterdMarkers.length} Result(s) Found`;
    }
  },

  goBackSearch() {
    this.newSearch?.addEventListener('click', () => {
      this.resultWrap?.classList.remove('activeClass');
      this.stockistAds?.classList.remove('activeClass');
      if (this.search) this.search.value = '';

      this.lat = 0;
      this.lng = 0;
      this.selectedTypes = [];

      this.typeBtns.forEach(cb => (cb.checked = false));

      this.filterdMarkers = [...this.markers];
      this.setMarkers();
      this.addPins();
      this.setCount();
      this.adjustMapBounds();
      this.hideErrorMessage();

      if (this.totalResultsElement) {
        this.totalResultsElement.innerText = '';
      }
    });
  },

handleSearchClick() {
  const searchTerm = this.search?.value.trim().toLowerCase() || '';

  // Filter markers by type first
  let filtered = [...this.markers];

  if (this.selectedTypes.length) {
    filtered = filtered.filter(marker => this.selectedTypes.includes(marker.type));
  }

  // Filter by search term if present
  if (searchTerm) {
    filtered = filtered.filter(marker => {
      return (
        marker.city.toLowerCase().includes(searchTerm) ||
        marker.state.toLowerCase().includes(searchTerm) ||
        marker.country.toLowerCase().includes(searchTerm) ||
        marker.name.toLowerCase().includes(searchTerm)
      );
    });
  }

  this.filterdMarkers = filtered;

  // Update UI & map pins
  this.setMarkers();
  this.addPins();
  this.setCounter();
  this.adjustMapBounds();

  // Hide error if results found, show if none
  if (this.filterdMarkers.length === 0) {
    this.showErrorMessage();
  } else {
    this.hideErrorMessage();
  }
},


    setResetMarkers() {
    this.resetMarkers?.addEventListener('click', () => {
      this.typeBtns.forEach(item => (item.checked = false));
      this.lat = 0;
      this.lng = 0;
      this.selectedTypes = [];
      if (this.search) this.search.value = '';
      this.filterdMarkers = [...this.markers];
      this.setMarkers();
      this.addPins();
      this.setCount();
      this.adjustMapBounds();
      this.hideErrorMessage();
    });
  },

  setCount() {
    if (this.markerCount) {
      this.markerCount.innerText = this.filterdMarkers.length
        ? `See ${this.filterdMarkers.length} Locations`
        : 'Select Option';
    }
  },

  toggleFilter() {
    this.typeFilterOpen?.addEventListener('click', () => {
      this.typeFilterOpen?.classList.toggle('activeClass');
      this.typeFilter?.classList.toggle('activeClass');
    });
  },

  zoomToPin() {
    this.storeList?.addEventListener('click', (e) => {
      const el = e.target as HTMLElement;
      if (el.classList.contains('jsMarkerLink')) {
        const lat = el.dataset.lat as string;
        const lng = el.dataset.lng as string;
        this.resultWrap?.classList.add('activeClass');
        this.resultBtn?.classList.add('activeClass');
        this.map.panTo({ lat: +lat, lng: +lng });
        this.map.setZoom(15);
      }
    });
  },

  getAtuoComResult() {
    const place = this.autocomplete?.getPlace();
    if (!place?.geometry) {
      window.alert("Autocomplete's returned place contains no geometry");
      return;
    }
    this.lat = place.geometry.location.lat();
    this.lng = place.geometry.location.lng();

    this.map.setCenter({ lat: this.lat, lng: this.lng });
    if (place.geometry.viewport) {
      this.map.fitBounds(place.geometry.viewport);
    } else {
      this.map.setCenter(place.geometry.location);
      this.map.setZoom(17);
    }
    console.log(place.geometry.viewport);
  },

  showErrorMessage() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'block';
    }
  },

  hideErrorMessage() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  },

  filterTypes() {
this.typeBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    const type = btn.dataset.type as Type;
    if (this.selectedTypes.includes(type)) {
      this.selectedTypes = this.selectedTypes.filter(t => t !== type);
      btn.classList.remove('activeClass');
    } else {
      this.selectedTypes.push(type);
      btn.classList.add('activeClass');
    }

    this.setAll();
  });
});
  },

setAll() {
  this.filterMarkers();
  this.setMarkers();
  this.addPins();

  // Instead of always calling adjustMapBounds, store current zoom and center,
  // and decide whether to fit bounds or keep zoom.

  if (this.filterdMarkers.length === 0) {
    // no markers - maybe show error or reset zoom
    this.adjustMapBounds();
  } else {
    this.adjustMapBounds();
  }
}
,

  filterMarkers() { 
    
    let markers = [...this.markers];

    if (this.lat && this.lng) {
      markers = markers
        .map((item) => ({ ...item, distance: this.calcDistance(item) }))
        .filter((item) => +item.distance < 20)
        .sort((a, b) => +a.distance - +b.distance);
    }

    if (this.selectedTypes.length) {
      markers = markers.filter((item) => this.selectedTypes.includes(item.type));
    }

    this.filterdMarkers = markers;
    this.setCounter();
  },

  createInfo(marker: Marker) {
    return `<h5 class="store-finder__info-title">${marker.name}</h5>
            <p class="store-finder__info-text">${marker.street1}, ${marker.city}, ${marker.state}, ${marker.zip}</p>`;
  },

addPins() {
  if (!this.map) return;

  this.deletePins(); // clear previous pins
  this.bounds = new google.maps.LatLngBounds();

  this.filterdMarkers.forEach((item) => {
    const lat = parseFloat(item.lat);
    const lng = parseFloat(item.lng);
    if (isNaN(lat) || isNaN(lng)) return;

    const position = { lat, lng };
    const marker = new google.maps.Marker({
      position,
      map: this.map,
    });

    const infoWindow = new google.maps.InfoWindow({
      content: this.createInfo(item),
    });

    marker.addListener('click', () => {
      infoWindow.open(this.map, marker);
    });

    this.pins.push(marker);
    this.bounds.extend(position); // important
  });

  this.adjustMapBounds(); // call again to zoom nicely
}
,

adjustMapBounds() {
  if (!this.map || !this.filterdMarkers.length) return;

  this.bounds = new google.maps.LatLngBounds();
  this.filterdMarkers.forEach((item) => {
    const lat = parseFloat(item.lat);
    const lng = parseFloat(item.lng);
    if (!isNaN(lat) && !isNaN(lng)) {
      this.bounds.extend({ lat, lng });
    }
  });

  this.map.fitBounds(this.bounds);

  // Optionally limit zoom in case of very close markers:
  const currentZoom = this.map.getZoom();
  if (currentZoom && currentZoom > this.defaultZoomLevel) {
    this.map.setZoom(this.defaultZoomLevel);
  }
}
,

  deletePins() {
    this.pins.forEach((pin) => pin.setMap(null));
    this.pins = [];
  },

  calcDistance(store: Marker) {
    const center = new google.maps.LatLng(this.lat, this.lng);
    const marker = new google.maps.LatLng(+store.lat, +store.lng);
    return (
      google.maps.geometry.spherical.computeDistanceBetween(center, marker) / 1000
    ).toFixed(2);
  },

  setTriger() {
    this.resultBtn?.addEventListener('click', () => {
      this.resultWrap?.classList.toggle('activeClass');
      this.resultBtn?.classList.toggle('activeClass');
    });
  },

  setMarkers() {
    if (this.storeList) {
      this.storeList.innerHTML = this.filterdMarkers
        .map((item, index) => this.createHtml(item, index + 1))
        .join('');
    }
  },

  createHtml(marker: Marker, index: number) {
    return `<li class="section-dealers__item" data-type="${marker.type}">
                <div class="section-dealers__item-wrap">
                <div class="section-dealers__item-title-wrap">
                    <h3 class="section-dealers__item-title jsMarkerLink" data-lat="${
                      marker.lat
                    }" data-lng="${marker.lng}">

                    <div class="section-dealers__counter-wrap">
                    <div class="section-dealers__count">
                    ${index} 
                    </div>
                    <svg>
                        <use xlink:href="#icon-pin"></use>
                    </svg> 
                    </div>
                     ${marker.name}
                    </h3>

                </div>
                
                <div class="section-dealers__item-links">
                    <p class="section-dealers__item-link-wrap">
  
                    <span class="section-dealers__item-link">
                      ${marker.street1 ? marker.street1 + ',' : ''}
                      ${marker.street2 ? marker.street2 + ',' : ''} 
                      ${marker.city}, ${marker.state}, ${marker.country}, ${
                        marker.zip
                      }
                    </span>
                    </p>

                    <p class="section-dealers__directions-link jsMarkerLink" data-lat="${
                      marker.lat
                    }" data-lng="${marker.lng}"">
                    Get Directions 
                    </p>
                    
                    <a href="tel:${
                      marker.phone
                    }" class="section-dealers__item-link-wrap">
                    <svg>
                        <use xlink:href="#icon-phone"></use>
                    </svg>
                    <span class="section-dealers__item-link">${marker.phone}</span>
                    </a>
                    <a href="tel:${
                      marker.email
                    }" class="section-dealers__item-link-wrap">
                    <svg>
                        <use xlink:href="#icon-email"></use>
                    </svg>
                    <span class="section-dealers__item-link">${marker.email}</span>
                    </a>
               
                    <div class="section-dealers__item-link-wrap">
                    <span class="section-dealers__item-link">${marker.type}</span>
                    </div> 
                  
                </div>
  
                </div>
                </div>

              <div class="section-dealers__btn-wrap"> 
              <div class="main-btn main-btn--bordered" ><span class="jsMarkerLink" data-lat="${marker.lat}" data-lng="${marker.lng}">Select</span></div>
              </div>

            </li>`;
  },

  async loadMap() {
    const mapDiv = document.getElementById('map');
    if (mapDiv) {
      const google = await this.loader.load();

      this.map = new google.maps.Map(mapDiv, {
        zoom: 0,
        center: { lat: -34.9285, lng: 138.6007 },
        styles: style,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
      }as google.maps.MapOptions);

      if (this.search) {
        this.autocomplete = new google.maps.places.Autocomplete(this.search, {
          fields: ['geometry', 'name'],
          types: ['(regions)'],
        });
        this.autocomplete.addListener('place_changed', () => {
          this.getAtuoComResult();
        });
      }

      this.filterdMarkers = [...this.markers];
      this.setMarkers();
      this.addPins();
      this.setCount();
      this.adjustMapBounds();
    }
  },
};

export default storeFinder;
